export default () => ({
  el: undefined,
  selectedFilter: undefined,
  addFilter: undefined,
  gridId: undefined,
  filterExecRequired: undefined,
  init() {
    mrp.log(`RxDataGridFilterControl init`);
    this.el = this.$el;
    this.filterExecRequired = this.$refs.filterExecRequired;
    this.gridId = this.el.getAttribute("data-grid-id");
    this.selectedFilter = this.$refs.selectedFilter;
    this.addFilter = this.$refs.addFilter;
    this.addFilter.setAttribute("disabled", "");
  },
  change() {
    if (this.selectedFilter.value === "") {
      this.addFilter.setAttribute("disabled", "");
      this.addFilter.removeAttribute("hx-get");
    } else {
      this.addFilter.removeAttribute("disabled");
      let option = this.selectedFilter.selectedOptions[0];
      this.addFilter.setAttribute(
        "hx-get",
        `/rx/data-grid/new-filter/${this.gridId}/${option.value}/${option.outerText}`
      );
      htmx.process(this.addFilter);
    }
  },
  filterAdded() {
    this.filterExecRequired.classList.remove("hidden");
  },
  executeFiltersClick(evt) {
    this.filterExecRequired.classList.add("hidden");
    evt.currentTarget.setAttribute("disabled", "");
    const indicator = document.getElementById("loading-filter");
    indicator.classList.add("filter-indicator-request");
    let arr = [];
    const filters = document.getElementById(`${this.gridId}-filters`);
    let filter = filters.firstChild;
    while (filter !== undefined && filter !== null) {
      let property = filter.getAttribute("data-filter-property");
      let operator = filter.querySelector('[name="filter-operator"]').value;
      let filterValue = filter.querySelector('[name="filter-value"]').value;

      let obj = {
        property: property,
        operation: operator,
        value: filterValue,
      };
      arr.push(obj);
      filter = filter.nextSibling;
    }
    const filterString = `filter=${encodeURIComponent(JSON.stringify(arr))}`;
    sessionStorage.setItem(`${this.gridId}-filter`, filterString);
    const endpoint = evt.currentTarget.getAttribute("data-endpoint");
    const sort = sessionStorage.getItem(`${this.gridId}-sort`) ?? "";
    const context = sessionStorage.getItem(`${this.gridId}-context`) ?? "";
    let path = `${endpoint}/1?focus=${evt.currentTarget.id}&${filterString}&${sort}&${context}`;
    htmx
      .ajax("GET", path, {
        target: `#${this.gridId}-data-grid`,
        swap: "outerHTML",
      })
      .then(() => {
        indicator.classList.remove("filter-indicator-request");
      });
  },
});
